module.exports = "/img/12.22d6ab.webp";